import { useCallback } from "react";
import SplashScreen from "@/components/splash-screen";
import RestaurantErrorScreen from "@/components/restaurant/RestaurantErrorScreen";
import { useRestaurant } from "@/hooks/use-restaurant";

type RestaurantBootstrapGateProps = {
  children: React.ReactNode;
};

/**
 * Blocks the application shell until restaurant configuration is loaded.
 */
export default function RestaurantBootstrapGate({
  children,
}: RestaurantBootstrapGateProps) {
  const { status, error, refetch } = useRestaurant();

  const handleRetry = useCallback(() => {
    void refetch({ force: true });
  }, [refetch]);

  if (status === "idle" || status === "loading") {
    return <SplashScreen />;
  }

  if (status === "error") {
    return (
      <RestaurantErrorScreen message={error?.message ?? null} onRetry={handleRetry} />
    );
  }

  return <>{children}</>;
}
